// extracted by mini-css-extract-plugin
export var banner = "_gs-0";
export var closeButton = "_gs-2";
export var greenCheckmark = "_gs-3";
export var hereLink = "_gs-4";
export var titleIcon = "_gs-1";